export { CarDetails as default } from "./CarDetails";
